import { render, staticRenderFns } from "./intercepting-well-detail.vue?vue&type=template&id=108246b3&scoped=true"
import script from "./intercepting-well-detail.vue?vue&type=script&lang=js"
export * from "./intercepting-well-detail.vue?vue&type=script&lang=js"
import style0 from "./intercepting-well-detail.vue?vue&type=style&index=0&id=108246b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108246b3",
  null
  
)

export default component.exports